export default __webpack_public_path__ + "ebf6e33e1ab956de004ab610e19bb54c.png";